/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { useReactiveVar } from '@apollo/client';
import * as React from 'react';
import { useHistory } from 'react-router-dom';

import { cancellationDialogDataVar, currentModeVar } from '../../../apollo/reactiveVariables/TemplateInstanceVariables';
import { Paths } from '../../../common/enums/Paths';
import { ScenarioName, StatusName, StepName } from '../../../logger';
import { getAppHost } from '../../../utilities/TeamsUtils';
import { getTemplateScenarioName, useIsTemplateInstanceChanged } from '../../../utilities/TemplateUtils';
import { TemplateManagementHeaderComponent } from './TemplateManagementHeader.component';

export const TemplateManagementHeaderContainer: React.FC = (): JSX.Element => {
    const host = getAppHost();
    const logger = host.getLogger();
    const history = useHistory();
    const currentMode = useReactiveVar(currentModeVar);
    const isTemplateInstanceChanged = useIsTemplateInstanceChanged(currentMode);

    const redirectToApprovalsApp = (): void => {
        logger.updateCommonProperty({ templateInstanceId: '' });
        logger.findScenario(ScenarioName.TemplateManagement)?.stop();
        logger.markScenarioComplete(ScenarioName.TemplateManagement);
        logger.markScenarioComplete(getTemplateScenarioName(currentMode));
        logger.markScenario(ScenarioName.PersonalApp, StepName.ExitTemplateManagementPage, StatusName.NA);
        history.replace(Paths.BasePath + Paths.ApprovalsApp);
    };

    const onClose = React.useCallback((): void => {
        if (isTemplateInstanceChanged) {
            cancellationDialogDataVar({
                isOpen: true,
                discardCallback: redirectToApprovalsApp,
            });
        } else {
            redirectToApprovalsApp();
        }
    }, [history, isTemplateInstanceChanged]);

    return <TemplateManagementHeaderComponent onClose={onClose} />;
};
